import { FormOption } from '../../../../../../../../types/Form';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import useEnumOptions from './useEnumOptions';

const useNaceCodeOptions = (question: FlowsQuestion): FormOption[] => {
  const naceCodeOptions = useEnumOptions(question, 'code');
  return naceCodeOptions;
};

export default useNaceCodeOptions;
